export default {
  select: 'Pick a date',
  monthNames: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
  monthNamesShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
  dayNames: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
  dayNamesShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_')
}
